<ng-container *ngIf="footer?.slices as slices">
  <ng-container *ngFor="let slice of slices">
    <app-footer-cta-area *ngIf="slice.type === 'cta_area'" [slice]="$any(slice)"></app-footer-cta-area>
    <app-footer-links-area class="relative" *ngIf="slice.type === 'links_area'" [slice]="$any(slice)">
    </app-footer-links-area>
    <app-footer-bottom-links-area class="relative" *ngIf="slice.type === 'bottom_links_area'" [slice]="$any(slice)">
    </app-footer-bottom-links-area>
  </ng-container>
</ng-container>
